import { useSelector } from "react-redux";

import { Button } from "@similarweb/ui-components";

import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { selectLoadingContactStatus } from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/selectors";

import {
    CUSTOM_MODAL_STYLES,
    StyledButtonsContainer,
    StyledMessage,
    StyledMessageText,
    StyledModalContent,
    StyledModalInner,
    StyledModalTitle,
} from "./styles";

type ApproveTermsModalProps = {
    isOpen: boolean;
    isLoading?: boolean;
    onCancel(): void;
    onApprove(): void;
    onAfterClose?(): void;
};

const ApproveTermsModal = ({ isOpen, isLoading, onCancel, onApprove, onAfterClose }: ApproveTermsModalProps) => {
    const isLoadingContactStatus = useSelector(selectLoadingContactStatus);

    return (
        <ProModal
            isOpen={isOpen}
            showCloseIcon={false}
            shouldCloseOnOverlayClick={true}
            customStyles={CUSTOM_MODAL_STYLES}
            onAfterClose={onAfterClose}
        >
            <StyledModalContent data-automation="approve-contact-terms-modal">
                <StyledModalInner>
                    <I18n
                        element={StyledModalTitle}
                        data-automation="title-text"
                        translatable={{ key: "si.contacts.approve-terms-modal.title" }}
                    />
                    <StyledMessage>
                        <StyledMessageText
                            data-automation="conversion-rate-modal.main-message"
                            dangerouslySetInnerHTML={{
                                __html: translate("si.contacts.approve-terms-modal.message"),
                            }}
                        />
                    </StyledMessage>
                </StyledModalInner>
                <StyledButtonsContainer>
                    <Button
                        type="flat"
                        onClick={onCancel}
                        dataAutomation="cancel-button"
                    >
                        {translate("si.common.button.cancel")}
                    </Button>
                    <Button
                        type="primary"
                        onClick={onApprove}
                        isLoading={isLoadingContactStatus || isLoading}
                        dataAutomation="apply-button"
                        isDisabled={isLoadingContactStatus || isLoading}
                    >
                        {translate("si.common.button.accept")}
                    </Button>
                </StyledButtonsContainer>
            </StyledModalContent>
        </ProModal>
    );
};

export default ApproveTermsModal;
